// import * as global from '../newGlobal';
import {isAutohomeApp, getCookie, getQueryString} from '../../../../common/util';
import {getCityFromIP, getAllProvinceCity} from '../../modules/store/api';
import store from '../../modules/store'

export default {
    data: function () {
        return {
            //城市id
            cityId: getQueryString('cityId', 0) ||getCookie('cookieCityId') || null,
            //城市名称
            cityName: '',
            provinceId: '',
            // 临时记录省份id，用在点选省份但没有点选城市的情况
            provinceIdTemp: '',
            provinceCityList: []
        };
    },
    mounted() {
        this.$eventBus.$on('allCityData', (data) => {
            const position = store.form.position;
            const {cityId, cityName, provinceId} = {...position};
            
            this.provinceCityList = store.provinceCityInfo;
            this.cityId = cityId;
            this.cityName = cityName;
            this.provinceId = provinceId;
        });
    },
    methods: {
        // 在app里使用系统定位
        getCityIdByNative: function () {
            var _this = this;
            if (this.compareAppVersion(getCookie('app_ver'), '9.13.5') === 'nowBig' || this.compareAppVersion(getCookie('app_ver'), '9.13.5') === 'equal') {
                AHAPP.invokeNative("getSyncCity", {
                    success: function (result) {
                        if (!result.result.cityId || !result.result.cityName || !result.result.provinceId) {
                            _this.getCityId();
                            return;
                        }
                        _this.cityId = result.result.cityId;
                        _this.cityName = result.result.cityName;
                        _this.provinceId = result.result.provinceId;
                        // 通过ip获取城市信息，对比城市信息是否一致，不一致上报
                        _this.checkCityIdForAppAndIp();
                    },
                    fail: function (result) {
                        _this.reportException('leads-getCityIdByNative-fail', {
                            returnParams: {
                                method: 'getSyncCity',
                                result: JSON.stringify(result)
                            }
                        });
                        _this.getCityId();
                    }
                });
            } else {
                _this.getCityId();
            }
        },
        showProvinceSidebar: function () {
            var provinceData = this.setProvinceData();
            if (provinceData.length) {
                try {
                    provinceSidebar.setData(provinceData);
                    this.provinceId = this.provinceId || provinceSidebar.state.list[0].list[0].id;
                    provinceSidebar.active(this.provinceId);
                    provinceSidebar.show();
                } catch (e) {
                    console.error(e);
                }
            }
        },
        showCitySidebar: function () {
            var cityData = this.setCityData(this.provinceIdTemp);
            if (cityData[0] && cityData[0].list && cityData[0].list.length) {
                try {
                    citySidebar.setData(cityData);
                    this.cityId = this.cityId || cityData[0].list[0].id;
                    citySidebar.active(this.cityId);
                    citySidebar.show();
                } catch (e) {
                    console.error(e);
                }
            }
        },
        // 根据省份set城市数据到侧边栏
        setCityData: function (provinceId) {
            var cityData = [{
                list: []
            }]
            if (this.provinceCityList && this.provinceCityList.length) {
                this.provinceCityList.forEach(function (item) {
                    // 按插件需要的方式组织数据
                    item.area.forEach(function (provinceItem) {
                        if (provinceItem.provinceId === provinceId) {
                            provinceItem.cityList.forEach(function (cityItem) {
                                cityData[0].list.push({
                                    id: cityItem.cityId,
                                    text: cityItem.cityName
                                })
                            })
                        }
                    })
                })
            }
            return cityData;
        },
        // set省份数据到侧边栏
        setProvinceData: function () {
            var provinceData = [];
            if (this.provinceCityList.length) {
                this.provinceCityList.forEach(function (item) {
                    var list = [];
                    // 按插件需要的方式组织省份数据
                    item.area.forEach(function (provinceItem) {
                        list.push({
                            id: provinceItem.provinceId,
                            text: provinceItem.provinceName
                        })
                    })
                    provinceData.push({
                        title: item.flag,
                        list: list
                    })
                })
            }
            return provinceData;
        },
        // M端城市联动
        getCookieCityIdForM: function () {
            if (this.getProvinceIdForM() && (this.getProvinceIdForM() + '').match(/^\d+$/) && this.getCityIdForM() && (this.getCityIdForM() + '').match(/^\d+$/)) {
                this.provinceId = this.getProvinceIdForM();
                this.cityId = this.getCityIdForM();
                return true;
            } else {
                return false;
            }
        },
        getProvinceIdForM: function (id) {
            if (id == undefined) {
                id = getCookie("cookieCityId", "0");
                id = id == "0" ? getCookie("area", "0") : id;
            }
            id = id.toString();
            id = id.toString();
            if (id == undefined || id.length != 6) {
                return 0;
            }
            var pId = id.substr(0, 2);
            if (pId == "99") {
                return 0;
            }

            return parseInt(pId + "0000", 10);
        },
        getCityIdForM: function (id) {
            var unExpInfoArr = { "1102": "1101", "1202": "1201", "3102": "3101", "5002": "5001" };//1102 的数据 已经没有了。这里还保留着。不删除。
            if (id == undefined) {
                id = getCookie("cookieCityId", "0");
                id = id == "0" ? getCookie("area", "0") : id;
            }
            id = id.toString();
            if (id == undefined || id.length != 6) {
                return 0;
            }
            if (id == '659301') { return 659003 };
            if (id == '659401') { return 659004 };
            var pId = id.substr(0, 2);
            var cId = id.substr(2, 2);
            if (pId == "99" || cId == "99" || cId == "00") {
                return 0;
            };
            if (cId == "90") {
                return parseInt(id, 10);
            };
            var _tmpId = id.substr(0, 4);
            if (unExpInfoArr[_tmpId]) {
                _tmpId = unExpInfoArr[_tmpId];
            };
            return parseInt(_tmpId + "00", 10);
        },
        setCityIdForM: function () {
            setCookie("cookieCityId", this.cityId, 24 * 30 * 3600 * 1000, 'autohome.com.cn');
        },
    }
};